import { sendPatientFax } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  PatientOutboundFaxesResponseT,
  SendPatientFaxRequestT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

import {
  documentRecipientFromMarkdown,
  documentTitleFromMarkdown,
  type DocumentDraft,
} from '@/entities/document-draft';

export async function sendFax(
  patientId: string,
  draft: DocumentDraft
): Promise<PatientOutboundFaxesResponseT['faxes'][number]> {
  const config = await createLotusRequestConfig();
  const recipient = documentRecipientFromMarkdown(draft.content.bodyMarkdown);
  const request: SendPatientFaxRequestT = {
    send_id: draft.id,
    title: documentTitleFromMarkdown(draft.content.bodyMarkdown),
    header_markdown: null,
    recipient: {
      name: recipient.name,
      organization: recipient.organization || null,
      fax_number: recipient.faxNumber,
    },
    attachments: draft.content.attachments.map(({ attachmentId }) => ({
      attachment_id: attachmentId,
    })),
    body_markdown: draft.content.bodyMarkdown.trim() || ' ',
    filename: 'fax.pdf',
  };
  const response = await sendPatientFax(patientId, request, config);
  const parsed = lotusHealthZod.fetchPatientOutboundFaxesResponse.parse({
    faxes: [response.data],
  });
  const fax = parsed.faxes[0];
  if (fax === undefined) {
    throw new Error('The send response did not include a fax.');
  }
  return fax;
}
